import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import { ConvenioFederalService } from "../../services/ConvenioFederalService";
import { ExercicioService } from "../../services/ExercicioService";

export default {
    name: "GerenciarConveniosFederais",
    components: {
        Breadcrumb,
        StandardPagination
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciar EP. Convênio Federal',
                disabled: true
            }
        ],
        baseHeaders: [
            { text: '', align: 'center', value: 'data-table-select', sortable: false, width: '50px' },
            { text: 'Exercício', align: 'center', value: 'exercicio', width: '150px' },
            { text: 'Parlamentar', align: 'center', value: 'parlamentar', width: '150px' },
            { text: 'Gerência', align: 'center', value: 'gerencia', width: '120px' },
            { text: 'Nº Convênio', align: 'center', value: 'numero_convenio', width: '120px' },
            { text: 'Nº Emenda', align: 'center', value: 'numero_emenda', width: '120px' },
            { text: 'Tipo de Emenda', align: 'center', value: 'tipo_emenda', width: '150px' },
            { text: 'Nº Proposta', align: 'center', value: 'numero_proposta', width: '120px' },
            { text: 'Unidade', align: 'center', value: 'unidade', width: '150px' },
            { text: 'Cidade(s)', align: 'center', value: 'cidades', width: '200px' },
            { text: 'Valor Emenda (R$)', align: 'center', value: 'valor_emenda', width: '150px' },
            { text: 'Valor Total Previsto (R$)', align: 'center', value: 'valor_total_previsto', width: '150px' },
        ],
        filters: {
            exercicioFilter: [],
            parlamentarFilter: null,
            gerenciaFilter: null,
            descricaoFilter: '',
            numeroConvenioFilter: '',
            numeroEmendaFilter: '',
            tipoEmendaFilter: null,
            numeroPropostaFilter: '',
            unidadeFilter: null,
            cobFilter: '',
            modalidadeFilter: null,
            cidadesFilter: [],
        },
        items: [],
        itemSelected: [],
        showFilters: true,
        page: 1,
        totalItems: 0,
        itemsPerPage: 10,
        loading: false,
        filterTimeout: null,
        // Opções para os filtros
        exerciciosOptions: [],
        parlamentaresOptions: [],
        gerenciasOptions: [],
        tiposEmendaOptions: [],
        unidadesOptions: [],
        modalidadesOptions: [],
        cidadesOptions: [],
        // Search inputs para autocomplete
        parlamentarSearch: '',
        unidadeSearch: '',
        cidadesSearch: '',
        // Timeouts para autocomplete
        parlamentarSearchTimeout: null,
        unidadeSearchTimeout: null,
        cidadesSearchTimeout: null,
    }),
    computed: {
        isAllSelected() {
            return this.items.length > 0 && this.itemSelected.length === this.items.length;
        },
        isIndeterminate() {
            return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
        },
        computedHeaders() {
            return this.baseHeaders;
        }
    },
    created() {
        this.listarConveniosFederaisPaginado();
        this.carregarOpcoesFiltros();
    },
    watch: {
        page: async function(newValue) {
            this.page = newValue;
            await this.listarConveniosFederaisPaginado();
        }
    },
    methods: {
        async listarConveniosFederaisPaginado() {
            try {
                this.loading = true;
                const filter = this.prepareFormFilter();

                const response = await ConvenioFederalService.index(filter);

                if (typeof response !== 'string' && response && response.data) {
                    this.items = response.data.data || [];
                    this.totalItems = response.data.total || 0;
                    this.itemSelected = [];
                    this.$forceUpdate();
                } else {
                    console.error('Não foi possível obter os convênios federais.');
                    this.items = [];
                    this.totalItems = 0;
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os convênios federais:', error);
                this.items = [];
                this.totalItems = 0;
            } finally {
                this.loading = false;
            }
        },
        async carregarOpcoesFiltros() {
            try {
                // Carregar exercícios
                const exerciciosResponse = await ExercicioService.select();
                if (exerciciosResponse && exerciciosResponse.data) {
                    this.exerciciosOptions = exerciciosResponse.data.map(exercicio => ({
                        text: String(exercicio.ano || exercicio.nome || exercicio.id),
                        value: exercicio.ano || exercicio.id
                    }));
                }

                // Carregar gerências
                const gerenciasResponse = await ConvenioFederalService.getGerenciasOptions();
                if (gerenciasResponse && gerenciasResponse.data) {
                    this.gerenciasOptions = gerenciasResponse.data.map(gerencia => ({
                        text: gerencia,
                        value: gerencia
                    }));
                }

                // Carregar tipos de emenda
                const tiposEmendaResponse = await ConvenioFederalService.getTiposEmendaOptions();
                if (tiposEmendaResponse && tiposEmendaResponse.data) {
                    this.tiposEmendaOptions = tiposEmendaResponse.data.map(tipo => ({
                        text: tipo,
                        value: tipo
                    }));
                }

                // Carregar modalidades
                const modalidadesResponse = await ConvenioFederalService.getModalidadesOptions();
                if (modalidadesResponse && modalidadesResponse.data) {
                    this.modalidadesOptions = modalidadesResponse.data.map(modalidade => ({
                        text: modalidade,
                        value: modalidade
                    }));
                }

                // Carregar opções iniciais de parlamentares
                await this.buscarParlamentaresOptions('');

                // Carregar opções iniciais de unidades
                await this.buscarUnidadesOptions('');

                // Carregar opções iniciais de cidades
                await this.buscarCidadesOptions('');
            } catch (error) {
                console.error('Ocorreu um erro ao carregar as opções dos filtros:', error);
            }
        },
        async buscarParlamentaresOptions(search = '') {
            try {
                const response = await ConvenioFederalService.autocomplete('deputado', search);
                if (response && response.data) {
                    this.parlamentaresOptions = response.data.map(parlamentar => ({
                        text: parlamentar,
                        value: parlamentar
                    }));
                }
            } catch (error) {
                console.error('Erro ao buscar parlamentares:', error);
            }
        },
        async buscarUnidadesOptions(search = '') {
            try {
                const response = await ConvenioFederalService.getUnidadesOptions(search);
                if (response && response.data) {
                    this.unidadesOptions = response.data.map(unidade => ({
                        text: unidade,
                        value: unidade
                    }));
                }
            } catch (error) {
                console.error('Erro ao buscar unidades:', error);
            }
        },
        async buscarCidadesOptions(search = '') {
            try {
                const response = await ConvenioFederalService.getCidadesOptions(search);
                if (response && response.data) {
                    this.cidadesOptions = response.data.map(cidade => ({
                        text: cidade,
                        value: cidade
                    }));
                }
            } catch (error) {
                console.error('Erro ao buscar cidades:', error);
            }
        },
        handleParlamentarSearch() {
            if (this.parlamentarSearchTimeout) {
                clearTimeout(this.parlamentarSearchTimeout);
            }
            this.parlamentarSearchTimeout = setTimeout(() => {
                this.buscarParlamentaresOptions(this.parlamentarSearch || '');
            }, 300);
        },
        handleUnidadeSearch() {
            if (this.unidadeSearchTimeout) {
                clearTimeout(this.unidadeSearchTimeout);
            }
            this.unidadeSearchTimeout = setTimeout(() => {
                this.buscarUnidadesOptions(this.unidadeSearch || '');
            }, 300);
        },
        handleCidadesSearch() {
            if (this.cidadesSearchTimeout) {
                clearTimeout(this.cidadesSearchTimeout);
            }
            this.cidadesSearchTimeout = setTimeout(() => {
                this.buscarCidadesOptions(this.cidadesSearch || '');
            }, 300);
        },
        prepareFormFilter() {
            const filter = new FormData();
            
            if (this.filters.exercicioFilter && this.filters.exercicioFilter.length > 0) {
                this.filters.exercicioFilter.forEach(exercicio => {
                    filter.append("exercicio[]", exercicio);
                });
            }
            
            if (this.filters.parlamentarFilter) {
                filter.append("parlamentar", this.filters.parlamentarFilter);
            }
            
            if (this.filters.gerenciaFilter) {
                filter.append("gerencia", this.filters.gerenciaFilter);
            }
            
            if (this.filters.descricaoFilter) {
                filter.append("descricao", this.filters.descricaoFilter);
            }
            
            if (this.filters.numeroConvenioFilter) {
                filter.append("numero_convenio", this.filters.numeroConvenioFilter);
            }
            
            if (this.filters.numeroEmendaFilter) {
                filter.append("numero_emenda", this.filters.numeroEmendaFilter);
            }
            
            if (this.filters.tipoEmendaFilter) {
                filter.append("tipo_emenda", this.filters.tipoEmendaFilter);
            }
            
            if (this.filters.numeroPropostaFilter) {
                filter.append("numero_proposta", this.filters.numeroPropostaFilter);
            }
            
            if (this.filters.unidadeFilter) {
                filter.append("unidade", this.filters.unidadeFilter);
            }
            
            if (this.filters.cobFilter) {
                filter.append("cob", this.filters.cobFilter);
            }
            
            if (this.filters.modalidadeFilter) {
                filter.append("modalidade", this.filters.modalidadeFilter);
            }
            
            if (this.filters.cidadesFilter && this.filters.cidadesFilter.length > 0) {
                this.filters.cidadesFilter.forEach(cidade => {
                    filter.append("cidades[]", cidade);
                });
            }
            
            filter.append("page", this.page);
            filter.append("per_page", this.itemsPerPage);
            
            return filter;
        },
        
        handlePageChanged(newPage) {
            this.page = newPage;
        },
        
        handleItemsPerPageChanged(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.page = 1;
            this.listarConveniosFederaisPaginado();
        },
        
        truncateText(text, maxLength) {
            if (!text || text.length <= maxLength) {
                return text || '-';
            }
            return text.substring(0, maxLength) + '...';
        },

        formatCurrency(value) {
            if (!value && value !== 0) {
                return '-';
            }
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        },

        formatUnidades(unidades) {
            if (!unidades) return '-';
            if (typeof unidades === 'string') {
                return unidades;
            }
            if (Array.isArray(unidades)) {
                return unidades.join(', ');
            }
            return String(unidades);
        },

        formatCidades(cidades) {
            if (!cidades) return '-';
            if (typeof cidades === 'string') {
                return cidades;
            }
            if (Array.isArray(cidades)) {
                return cidades.join(', ');
            }
            return String(cidades);
        },
        
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.itemSelected = [];
            } else {
                this.itemSelected = [...this.items];
            }
        },

        toggleFilters() {
            this.showFilters = !this.showFilters;
        },
        
        clearFilters() {
            this.filters = {
                exercicioFilter: [],
                parlamentarFilter: null,
                gerenciaFilter: null,
                descricaoFilter: '',
                numeroConvenioFilter: '',
                numeroEmendaFilter: '',
                tipoEmendaFilter: null,
                numeroPropostaFilter: '',
                unidadeFilter: null,
                cobFilter: '',
                modalidadeFilter: null,
                cidadesFilter: [],
            };
            this.parlamentarSearch = '';
            this.unidadeSearch = '';
            this.cidadesSearch = '';
            this.page = 1;
            this.listarConveniosFederaisPaginado();
        },
        
        handleFilterChange() {
            // Debounce para evitar muitas chamadas à API
            if (this.filterTimeout) {
                clearTimeout(this.filterTimeout);
            }
            
            this.filterTimeout = setTimeout(() => {
                this.page = 1;
                this.listarConveniosFederaisPaginado();
            }, 300);
        },

        getRowClass() {
            return 'row-standard';
        }
    }
};

